export const urls = "http://10.50.30.112:9000/work";